import { IdSvrAuthService } from "../../../auth/idSrvAuthService";

(function (module) {
    "use strict";
    module.controller('ConfigurationCtrl', [IdSvrAuthService.componentName, 'configurationPeriodService', 'forecastConfigurationService', ConfigurationCtrl]);

    function ConfigurationCtrl(
        this: $TSFixMe,
        authService: IdSvrAuthService,
        configurationPeriodService: $TSFixMe,
        forecastConfigurationService: $TSFixMe
    ) {
        var $ctrl = this;

        $ctrl.serverOperation = configurationPeriodService.get().then(function (config: $TSFixMe) {
            $ctrl.config = config;
        });

        authService.hasPermissionAsync('ViewMarketBrand').then(result => $ctrl.canViewMarketBrand = result);
        authService.hasPermissionAsync('ViewMarketProduct').then(result => $ctrl.canViewMarketProduct = result);
        authService.hasPermissionAsync('ManageConfig').then(result => $ctrl.canManageConfig = result);
        authService.hasPermissionAsync('ViewScoringCardSummary').then(result => $ctrl.canViewScoringCardSummary = result);

        $ctrl.actions = {
            save: function () {
                $ctrl.serverOperation = configurationPeriodService.save($ctrl.config);
            }
        }

        $ctrl.riskOptions = {
            dataProvider: function (options: $TSFixMe) {
                return forecastConfigurationService.getRisks();
            },
            callbacks: {
                add: forecastConfigurationService.addRisk,
                edit: forecastConfigurationService.editRisk
            },
            nameText: 'CONFIGURATION.FORECAST.RISK_NAME',
            valueText: 'CONFIGURATION.FORECAST.RISK_VALUE'
        };

    }

})(angular.module('topline.modules'));